class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer-inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer-inner') || this.querySelector('.drawer-close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
  window.__cartDrawerRendering = true;   // ← ADD THIS

  this.querySelector('.drawer-inner').classList.contains('is-empty') &&
    this.querySelector('.drawer-inner').classList.remove('is-empty');

  this.productId = parsedState.id;

  this.getSectionsToRender().forEach((section) => {
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);
    sectionElement.innerHTML = this.getSectionInnerHTML(
      parsedState.sections[section.id],
      section.selector
    );
  });

  setTimeout(() => {
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.open();

    if (typeof bindAutoshipEvents === 'function') bindAutoshipEvents();
    if (typeof window.refreshCartDrawerUpsell === 'function') window.refreshCartDrawerUpsell();
    if (typeof refreshVoucherSystem === 'function') refreshVoucherSystem();
    if (typeof initLoopBundle === 'function') initLoopBundle('LOOP_heekrv-gq_bundles_drawer');
    if (window.reinitializeSmile) reinitializeSmile();

    window.__cartDrawerRendering = false;  
  });
}

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

function defineCartDrawerItems() {
  if (typeof CartItems === 'undefined') {
    setTimeout(defineCartDrawerItems, 50);
    return;
  }

  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer-inner'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }
  }

  if (!customElements.get('cart-drawer-items')) {
    customElements.define('cart-drawer-items', CartDrawerItems);
  }
}

defineCartDrawerItems();

let smileInitTimeout = null;
let smileInitialized = false;

function reinitializeSmile() {
  if (smileInitialized) return;

  clearTimeout(smileInitTimeout);

  smileInitTimeout = setTimeout(() => {
    if (window.Smile && window.Smile.UI) {
      try {
        window.Smile.UI.reinitialize();
        smileInitialized = true;
        document.dispatchEvent(new Event('smile:reinitialize'));
      } catch (e) {
        console.warn('Smile reinit error', e);
      }
    }
  }, 500);
}

document.addEventListener('cart:updated', () => {
  if (window.refreshCartDrawerUpsell) {
    window.refreshCartDrawerUpsell();
  }
});

document.addEventListener('cart:updated', () => {

  if (window.refreshCartDrawerUI) {
    window.refreshCartDrawerUI();
  }

  smileInitialized = false;
  reinitializeSmile();
});